import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-4958b64f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ads"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex fy-c fx-c w100 h100"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "default w100 h100",
  src: _imports_0
})], -1));
export default {
  __name: 'AdContainer',
  props: {
    link: String,
    imgUrl: String
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("a", {
        href: __props.link
      }, [_createVNode(_component_el_image, {
        class: "w100",
        src: __props.imgUrl,
        fit: "contain",
        loading: "lazy"
      }, {
        placeholder: _withCtx(() => [_hoisted_3]),
        _: 1
      }, 8, ["src"])], 8, _hoisted_2)]);
    };
  }
};